/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  ChainId,
  // TokenAmount, 
  ETHER
} from 'goswap-sdk'
import React
  // , { useState } 
  from 'react'
import { Text } from 'rebass'
import { NavLink } from 'react-router-dom'
// import { darken } from 'polished'
import { useTranslation } from 'react-i18next'

import styled from 'styled-components'

import Logo from '../../assets/images/goswap_logo.png'
import LogoDark from '../../assets/images/goswap_logo_dark.png'
import { useActiveWeb3React } from '../../hooks'
import { useDarkModeManager } from '../../state/user/hooks'
import {
  useETHBalances
  // , useAggregateUniBalance 
} from '../../state/wallet/hooks'
// import { CardNoise } from '../earn/styled'
// import { CountUp } from 'use-count-up'
import {
  // TYPE, 
  ExternalLink
} from '../../theme'

import { YellowCard } from '../Card'
import Settings from '../Settings'
// import Menu from '../Menu'

import Row, { RowFixed } from '../Row'
import Web3Status from '../Web3Status'
import ClaimModal from '../claim/ClaimModal'
// import { useToggleSelfClaimModal, useShowClaimPopup } from '../../state/application/hooks'
// import { useUserHasAvailableClaim } from '../../state/claim/hooks'
// import { useUserHasSubmittedClaim } from '../../state/transactions/hooks'
// import { Dots } from '../swap/styleds'
// import Modal from '../Modal'
// import UniBalanceContent from './UniBalanceContent'
// import usePrevious from '../../hooks/usePrevious'
import { darken } from 'polished'
import I18nSwitch from '../I18nSwitch'
// @ts-ignore
import useInfoLink from '../../hooks/useInfoLink'
// @ts-ignore
import useMiningLink from '../../hooks/useMiningLink'
// @ts-ignore
import useNetworkType from '../../hooks/useNetworkType'

const HeaderFrame = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  width: 100%;
  top: 0;
  position: relative;
  padding: 18px 80px;
  /* background-color: rgba(8, 8, 8, 0.25); */
  z-index: 2;
  @media only screen and (max-width: 1120px) and (min-width: 961px) {
    padding: 18px 20px;

  }
  @media only screen and (max-width: 960px) {
      border-bottom: 2px solid #A4A9E81A; 
  }
  
  ${({ theme }) => theme.mediaWidth.upToMedium`
    grid-template-columns: 1fr;
    padding: 0 1rem;
    width: calc(100%);
    position: relative;
  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    padding: 13px 10px 6px 10px;
  `}
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: flex-end;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: row;
    justify-content: flex-end;
    justify-self: center;
    max-width: 960px;
    padding: 0.2rem 0 0.2rem 0px;
    // width: 100%;
    z-index: 99;
    // height: 62px;
    border-radius: 12px 12px 0 0;
    // background-color: ${({ theme }) => theme.bg1};
  `};
`

const HeaderElement = styled.div`
  display: flex;
  align-items: center;
  // gap: 8px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: row-reverse;
    align-items: center;
  `};
`

const HeaderElementWrap = styled.div`
  display: flex;
  align-items: center;
`

const HeaderRow = styled(RowFixed)`
  flex:1;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    // display: grid;
    grid-template-columns: 100%;
    grid-template-rows: repeat(2, auto);
    width: 100%;
  `};
  @media only screen and (max-width: 1120px) and (min-width: 961px) {
    display: flex;
    // flex-direction: column;
    align-items: flex-start;
  }
`

const HeaderLinks = styled(Row)`
  // justify-content: center;
  flex-wrap: wrap;
  line-height: 30px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 1rem 0 1rem 1rem;
  `};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    grid-row: 1;
  `};
  @media only screen and (max-width: 1120px) and (min-width: 961px) {
    padding-top: 6px;
  }
  @media only screen and (max-width: 500px) {
    padding-top: 6px;
    display:none;
  }
`

const AccountElement = styled.div < { active: boolean } > `
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => (theme.isDarkMode ? theme.primary1 : theme.bg3)};
  border-radius: 12px;
  white-space: nowrap;
  width: 100%;
  cursor: pointer;

  :focus {
    border: 1px solid blue;
  }
  /* :hover {
    background-color: ${({ theme, active }) => (!active ? theme.bg2 : theme.bg4)};
  } */
`

// const UNIAmount = styled(AccountElement)`
//   color: ${({ theme }) => theme.text2};
//   padding: 4px 8px;
//   height: 36px;
//   font-weight: 500;
//   background-color: ${({ theme }) => theme.bg3};
//   background: ${({ theme }) =>
//     `radial-gradient(174.47% 188.91% at 1.84% -2%, ${theme.isDarkMode ? theme.primary1 : theme.bg3} 0%, ${
//       theme.isDarkMode ? theme.primary1 : theme.bg3
//     } 255%) 80%, ${theme.isDarkMode ? theme.primary1 : theme.bg3} 100%`};
// `

// const UNIWrapper = styled.span`
//   width: fit-content;
//   position: relative;
//   cursor: pointer;

//   :hover {
//     opacity: 0.8;
//   }

//   :active {
//     opacity: 0.9;
//   }
// `

const HideSmall = styled.span`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};
`

const NetworkCard = styled(YellowCard)`
  white-space: nowrap;
  border-radius: 12px;
  padding: 8px 12px;
  display: none;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 0;
    margin-right: 0.5rem;
    width: initial;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
  `};
`

const BalanceText = styled(Text)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
`

const Title = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  justify-self: flex-start;
  margin-right: 12px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-self: center;
  `};
  :hover {
    cursor: pointer;
  }
`

const UniIcon = styled.div`
  height: 30px;
  width: auto;
  transition: transform 0.3s ease;
  :hover {
    transform: rotate(-5deg);
  }
`


const activeClassName = 'ACTIVE'

const StyledNavLink = styled(NavLink).attrs({
  activeClassName
})`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  border-radius: 3rem;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: 1rem;
  width: fit-content;
  margin: 0 12px;
  font-weight: 500;

  &.${activeClassName} {
    border-radius: 12px;
    font-weight: bold;
    color: ${({ theme }) => theme.text1};
  }

  :hover,
  :focus {
    color: ${({ theme }) => darken(0.1, theme.text1)};
  }

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin: 0 8px;
  `}
`
// @ts-ignore
const StyledExternalLink = styled(ExternalLink).attrs({
  activeClassName
}) < { isActive?: boolean } > `
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  border-radius: 3rem;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: 1rem;
  width: fit-content;
  margin: 0 12px;
  font-weight: 500;

  &.${activeClassName} {
    border-radius: 12px;
    font-weight: bold;
    color: ${({ theme }) => theme.text1};
  }

  :hover,
  :focus {
    color: ${({ theme }) => darken(0.1, theme.text1)};
  }

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin: 0 8px;
  `}
`

const NETWORK_LABELS: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: 'KTO Test',
  [ChainId.KTOTEST]: 'KTO Test',
  [ChainId.KTOMAIN]: 'KTO Mainnet',
}

export default function Header() {
  const { account, chainId } = useActiveWeb3React()
  const { t } = useTranslation()

  const userEthBalance = useETHBalances(account ? [account] : [])?.[account ?? '']
  const [isDark] = useDarkModeManager()

  // const toggleClaimModal = useToggleSelfClaimModal()

  // const availableClaim: boolean = useUserHasAvailableClaim(account)

  // const { claimTxn } = useUserHasSubmittedClaim(account ?? undefined)

  // const aggregateBalance: TokenAmount | undefined = useAggregateUniBalance()

  // const [showUniBalanceModal, setShowUniBalanceModal] = useState(false)
  // const showClaimPopup = useShowClaimPopup()

  // const countUpValue = aggregateBalance?.toFixed(0) ?? '0'
  // const countUpValuePrevious = usePrevious(countUpValue) ?? '0'
  // const infoLink = useInfoLink(chainId)
  // const miningLink = useMiningLink(chainId)
  // const networkType = useNetworkType(chainId)

  return (
    <HeaderFrame>
      <ClaimModal />
      {/* <Modal isOpen={showUniBalanceModal} onDismiss={() => setShowUniBalanceModal(false)}>
        <UniBalanceContent setShowUniBalanceModal={setShowUniBalanceModal} />
      </Modal> */}
      <HeaderRow>
        <Title href=".">
          <UniIcon>
            <img height="30px" src={isDark ? LogoDark : Logo} alt="logo" />
          </UniIcon>
        </Title>
        <HeaderLinks>
          <StyledNavLink id={`explore-nav-link`} to={'/explore'}>
            {t('explore')}
          </StyledNavLink>

          <StyledNavLink
            id={`pool-nav-link`}
            to={'/pool'}
            isActive={(match, { pathname }) =>
              Boolean(match) ||
              pathname.startsWith('/add') ||
              pathname.startsWith('/remove') ||
              pathname.startsWith('/create') ||
              pathname.startsWith('/find')
            }
          >
            {t('pool')}
          </StyledNavLink>
          <StyledNavLink id={`swap-nav-link`} to={'/swap'}>
            {t('swap')}
          </StyledNavLink>
          <StyledNavLink id={`stake-nav-link`} to={'/finds'}>
            {t('tabbarfx')}
          </StyledNavLink>
          {/* <a className="sc-krDsej OGJAj" id={`stake-nav-link`} href="http://uft.web3s.finance/#/">{t('gofarm')} <span style={{ fontSize: '11px' }}>↗</span></a> */}
          <StyledExternalLink id={`stake-nav-link`} href={"http://uft.web3s.finance/#/"}>
            {t('gofarm')} <span style={{ fontSize: '11px' }}>↗</span>
          </StyledExternalLink>
          <StyledExternalLink id={`stake-nav-link`} href={"https://ktobridge.web3s.finance/"}>
            {t('ktoBridge')} <span style={{ fontSize: '11px' }}>↗</span>
          </StyledExternalLink>
          <StyledExternalLink id={`stake-nav-link`} href={"https://commonbox.io/#/"}>
            {t('nftbox')} <span style={{ fontSize: '11px' }}>↗</span>
          </StyledExternalLink>
          {/* <StyledNavLink id={`stake-nav-link`} to={'/best'}>
            BEST
          </StyledNavLink>
          <StyledNavLink id={`stake-nav-link`} to={'/vote'}>
            Vote
          </StyledNavLink> */}
          {/**  导航栏
          <StyledExternalLink id={`stake-nav-link`} href={miningLink}>
            {t('mining')} <span style={{ fontSize: '11px' }}>↗</span>
          </StyledExternalLink>
          <StyledExternalLink id={`stake-nav-link`} href={infoLink}>
            {t('info')} <span style={{ fontSize: '11px' }}>↗</span>
          </StyledExternalLink>
          <StyledExternalLink id={`stake-nav-link`} href={"https://farm.goswap.app/#/"}>
            {t('gofarm')} <span style={{ fontSize: '11px' }}>↗</span>
          </StyledExternalLink>
          {networkType === 'BSC' && (
            <StyledExternalLink id={`stake-nav-link`} href={'https://www.binance.org/en/bridge'}>
              {t('bridge')} <span style={{ fontSize: '11px' }}>↗</span>
            </StyledExternalLink>
          )}
          */}
        </HeaderLinks>
      </HeaderRow>
      <HeaderControls>
        <HeaderElementWrap>
          <Settings />
          <I18nSwitch />
          {/* <Menu /> */}
        </HeaderElementWrap>
        <HeaderElement>
          <HideSmall>
            {chainId && NETWORK_LABELS[chainId] && (
              <NetworkCard title={NETWORK_LABELS[chainId]}>{NETWORK_LABELS[chainId]}</NetworkCard>
            )}
          </HideSmall>
          {/* {availableClaim && !showClaimPopup && (
            <UNIWrapper onClick={toggleClaimModal}>
              <UNIAmount active={!!account && !availableClaim} style={{ pointerEvents: 'auto' }}>
                <TYPE.white padding="0 2px">
                  {claimTxn && !claimTxn?.receipt ? <Dots>{t('claiming')} SCAM</Dots> : t('claimScam')}
                </TYPE.white>
              </UNIAmount>
              <CardNoise />
            </UNIWrapper>
          )} */}
          {/*edit by peng.su*/}
          {/* {false && !availableClaim && aggregateBalance && (
            <UNIWrapper onClick={() => setShowUniBalanceModal(true)}>
              <UNIAmount active={!!account && !availableClaim} style={{ pointerEvents: 'auto' }}>
                {account && (
                  <HideSmall>
                    <TYPE.main
                      style={{
                        paddingRight: '.4rem'
                      }}
                    >
                      <CountUp
                        key={countUpValue}
                        isCounting
                        start={parseFloat(countUpValuePrevious)}
                        end={parseFloat(countUpValue)}
                        thousandsSeparator={','}
                        duration={1}
                      />
                    </TYPE.main>
                  </HideSmall>
                )}
                SCAM
              </UNIAmount>
              <CardNoise />
            </UNIWrapper>
          )} */}
          {/* <AccountElement active={!!account} style={{ pointerEvents: 'auto' }}>
            {account && userEthBalance ? (
              <BalanceText style={{ flexShrink: 0 }} pl="0.75rem" pr="0.5rem" fontWeight={500}>
                {(userEthBalance)?.toSignificant(4)} {ETHER.toDisplayableSymbol(chainId!)}
              </BalanceText>
            ) : null}
            <Web3Status />
          </AccountElement> */}
          <AccountElement active={!!account} style={{ pointerEvents: 'auto' }}>
            {account && userEthBalance ? (
              <BalanceText style={{ flexShrink: 0, display: 'none' }} pl="0.75rem" pr="0.5rem" fontWeight={500}>
                {(userEthBalance)?.toSignificant(4)} {ETHER.toDisplayableSymbol(chainId!)}
              </BalanceText>
            ) : null}
            <Web3Status />
          </AccountElement>
        </HeaderElement>
      </HeaderControls>
    </HeaderFrame >
  )
}
